"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var routes = {};
var _default = exports["default"] = routes;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJyb3V0ZXMiLCJfZGVmYXVsdCIsImV4cG9ydHMiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9saWJyYXJ5L3NyYy9jbGllbnQvbW9kdWxlcy9Db250ZW50L0FydGljbGVDYXRlZ29yeS9BcnRpY2xlQ2F0ZWdvcnlSb3V0ZXMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3Qgcm91dGVzID0ge31cclxuXHJcbmV4cG9ydCBkZWZhdWx0IHJvdXRlczsiXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLElBQU1BLE1BQU0sR0FBRyxDQUFDLENBQUM7QUFBQSxJQUFBQyxRQUFBLEdBQUFDLE9BQUEsY0FFRkYsTUFBTSJ9